<template>
  <div class="border-style">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.border-style {
  @include border-style-1;
}
</style>
